export const CommonFeatureAuthCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Autorizzazioni',
    path: '/sistema/feature-auth',
  },
];
